var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w-100 d-flex justify-content-between align-items-end"},[_c('router-link',{attrs:{"to":"/"}},[_c('Logo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }